import Annotation from 'components/Annotation'
import { AnnotationTextMarker as TM } from 'components/Annotation/AnnotationTextMarker'
import { CircleAnnotation } from 'components/Annotation/CircleAnnotation'

const isMobile = window.innerWidth < 712

export const zurich_data: CityData = {
  name: 'Zürich',
  bfsid: '261',
  sat_images: [
    {
      label: 'Ärmer - Schwamendingen',
      image: isMobile
        ? require('../../../Content/Maps/maps_261_sat_poor_mob.jpg')
        : require('../../../Content/Maps/maps_261_sat_poor.jpg'),
    },
    {
      label: 'Reicher - Zürichberg',
      image: isMobile
        ? require('../../../Content/Maps/maps_261_sat_rich_mob.jpg')
        : require('../../../Content/Maps/maps_261_sat_rich.jpg'),
    },
  ],
  elements: [
    {
      id: 'all',
      text: (
        <>
          <p>
            In Zürich fällt die Ballung der Reichen auf dem <TM prio={2}>Zürichberg</TM>{' '}
            und in <TM prio={2}>Höngg</TM> auf. Gleichzeitig sind Mosaikstrukturen
            insbesondere südlich des Hauptbahnhofs erkennbar – hier ist die
            soziale Durchmischung relativ gross. Viele Quartiere mit ärmeren
            Bewohnerinnen und Bewohnern befinden sich ausserhalb des Zentrums.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 40 : 80}
              angle={isMobile ? 290 : 35}
            >
              Zürichberg
            </CircleAnnotation>
          ),
          position: { x: 62, y: 50 },
          position_mobile: { x: 68, y: 43 },
        },
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 40 : 60}
              angle={isMobile ? 260 : 257}
            >
              Höngg
            </CircleAnnotation>
          ),
          position: { x: 34, y: 33 },
          position_mobile: { x: 28, y: 26 },
        },

        {
          content: <Annotation priority={3}>Aussersihl</Annotation>,
          position: { x: 28, y: 53 },
          position_mobile: { x: 16, y: 48 },
        },
        {
          content: <Annotation priority={3}>Friesenberg</Annotation>,
          position: { x: 23, y: 65 },
          position_mobile: { x: 12, y: 60 },
        },
        {
          content: <Annotation priority={3}>Schwamendingen</Annotation>,
          position: { x: 60, y: 34 },
          // position_mobile: { x: 70, y: 35 },
        },
        {
          content: <Annotation priority={3}>Seefeld</Annotation>,
          position: { x: 51, y: 64 },
          position_mobile: { x: 55, y: 62 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_261_all_mob.jpg')
        : require('../../../Content/Maps/maps_261_all.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_261_all_mob_dm.jpg')
        : require('../../../Content/Maps/maps_261_all_dm.jpg'),
    },
    {
      id: 'rich',
      text: (
        <>
          <p>
            Schon gegen Ende des 19. Jahrhunderts haben sich reiche Zünfter in
            Villen und Appartementhäusern am <TM prio={2}>Zürichberg</TM> niedergelassen.
            Die südexponierte Hanglage ist bis heute eine privilegierte
            Wohngegend.
          </p>
          <p>
            Die scharfe Trennung zwischen armen und reichen Wohngegenden – mit
            dem <TM prio={4}>Bahnhof</TM> als Riegel – prägt die Stadt.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation
              size={isMobile ? 40 : 80}
              angle={isMobile ? 290 : 35}
            >
              Zürichberg
            </CircleAnnotation>
          ),
          position: { x: 62, y: 50 },
          position_mobile: { x: 68, y: 43 },
        },
        // {
        //   content: <Annotation priority={3}>Höngg</Annotation>,
        //   position: { x: 27, y: 27 },
        //   position_mobile: { x: 20, y: 27 },
        // },
        {
          content: <Annotation priority={3}>Seefeld</Annotation>,
          position: { x: 51, y: 64 },
          position_mobile: { x: 55, y: 62 },
        },
        {
          content: <Annotation priority={3}>Aussersihl</Annotation>,
          position: { x: 28, y: 53 },
          position_mobile: { x: 16, y: 48 },
        },
        {
          content: <Annotation priority={3}>Friesenberg</Annotation>,
          position: { x: 23, y: 65 },
          position_mobile: { x: 12, y: 60 },
        },
        {
          content: <Annotation priority={3}>Schwamendingen</Annotation>,
          position: { x: 60, y: 34 },
          // position_mobile: { x: 70, y: 35 },
        },
 

        {
          content: (
            <Annotation
              exactLocation
              align='middle'
              priority={2}
              offset={isMobile ? 60 : 140}
            >
              Bahngleise
            </Annotation>
          ),
          position: { x: 43, y: 31 },
          position_mobile: { x: 40, y: 28 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_261_rich_mob.jpg')
        : require('../../../Content/Maps/maps_261_rich.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_261_rich_mob_dm.jpg')
        : require('../../../Content/Maps/maps_261_rich_dm.jpg'),
    },
    {
      id: 'poor',
      text: (
        <>
          <p>
            Die Armen liessen sich in <TM prio={3}>Aussersihl</TM> nieder – in den
            Kreisen 3, 4 und 9. Hier entstanden Ende des 19. Jahrhunderts
            sogenannte «Arrival Cities» für meist ausländische Arbeiterinnen und
            Arbeiter. Dazu gehörten viele Kneipen und das Sexgewerbe. Zunächst
            baute die Stadt hier Baracken, später Blockrandbauten.
          </p>
          <p>
            Viele dieser früheren Arbeiterquartiere sind heute von Reichen
            bewohnt. Arme wohnen insbesondere noch an weniger attraktiven Lagen
            entlang von Eisenbahnlinien und Autobahnen.
          </p>
          <p>
            Gut erkennbar sind die Gartenstädte von <TM prio={3}>Schwamendingen</TM> im
            Norden und <TM prio={3}>Friesenberg</TM> im Süden. Dort können sich weniger
            Vermögende halten, weil sie in Genossenschaften wohnen.
          </p>
        </>
      ),
      annotations: [
        {
          content: (
            <CircleAnnotation size={isMobile?30:60} angle={isMobile?50:135}>
              Aussersihl
            </CircleAnnotation>
          ),
          position: { x: 37, y: 50 },
          position_mobile: { x: 37, y: 43 },
        },
        {
          content: (
            <CircleAnnotation size={isMobile?30:50} angle={isMobile?91:135}>
              Friesenberg
            </CircleAnnotation>
          ),
          position: { x: 34, y: 63 },
          position_mobile: { x: 34, y: 58 },
        },
        {
          content: (
            <CircleAnnotation size={isMobile?30:40} angle={isMobile ? 105 : 90}>
              Schwamendingen
            </CircleAnnotation>
          ),
          position: { x: 70, y: 30 },
          position_mobile: { x: 83, y: 25 },
        },
 {
          content: <Annotation priority={3}>Höngg</Annotation>,
          position: { x: 27, y: 27 },
          position_mobile: { x: 20, y: 27 },
        },
        {
          content: <Annotation priority={3}>Seefeld</Annotation>,
          position: { x: 51, y: 64 },
          position_mobile: { x: 55, y: 62 },
        },
      ],
      image: isMobile
        ? require('../../../Content/Maps/maps_261_poor_mob.jpg')
        : require('../../../Content/Maps/maps_261_poor.jpg'),
      image_dm: isMobile
        ? require('../../../Content/Maps/maps_261_poor_mob_dm.jpg')
        : require('../../../Content/Maps/maps_261_poor_dm.jpg'),
    },
  ],
}
